import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForAuthorisation } from "./context";
import { auth, firestore } from "./firebase";
import { doc, getDoc, onSnapshot } from "firebase/firestore";

let renderRef = true;

const Logout = () => {
  //logout is is used by function logout below, & it comes from context.js & is linked to context hook
  const { logout } = useForAuthorisation();
  const historyPage = useNavigate();
  const [errorMessage, setErrorMessage] = useState();
  let MainUserUID = auth?.currentUser?.uid;
  const [getUsers, setGetUsers] = useState([]);
  const [newData, setNewData] = useState([]);
  // const [uid, setUID] = useState("");
  useEffect(() => {
    if (!MainUserUID) return;
    setLoadingApp11(true);

    const ownerDocRef = doc(firestore, "Owner", MainUserUID);
    const unsubscribe = onSnapshot(
      ownerDocRef,
      (docSnap) => {
        if (docSnap.exists()) {
          const data = docSnap.data();
          setGetUsers([{ id: docSnap.id, ...data }]);
          //  setThemeColors([{ ...data }]);
        } else {
          setGetUsers([]);
          //  setThemeColors([]);
        }
        setLoadingApp11(false);
      },
      (err) => {
        console.log("error", err);
        setLoadingApp11(false);
      }
    );

    return () => {
      unsubscribe();
    };
  }, [MainUserUID]);
  //
  useEffect(() => {
    if (!MainUserUID) return;
    setLoadingApp11(true);

    const ownerDocRef = doc(firestore, "UserSelections", MainUserUID);
    const unsubscribe = onSnapshot(
      ownerDocRef,
      (docSnap) => {
        if (docSnap.exists()) {
          const data = docSnap.data();

          setNewData([{ ...data }]);
        } else {
          setNewData([]);
        }
        setLoadingApp11(false);
      },
      (err) => {
        console.log("error", err);
        setLoadingApp11(false);
      }
    );

    return () => {
      unsubscribe();
    };
  }, [MainUserUID]);
  //
  const [uid, setUID] = useState("");

  useEffect(() => {
    if (renderRef) {
      renderRef = false;
      return;
    }
    getUsers.map((el) => setUID(el.MAINuserId));
  }, [getUsers]);

  //const [companySelectedIdKey, setcompanySelectedIdKey] = useState("");
  const [businessSelected, setbusinessSelected] = useState("");

  useEffect(() => {
    let stop = false;
    if (stop) return;

    if (!uid) return;

    const DocRef = doc(firestore, "BusinessesAdded", uid);
    const unsubscribe = onSnapshot(
      DocRef,
      (docSnap) => {
        if (docSnap.exists()) {
          const data = docSnap.data();
          setbusinessSelected(data.businessSelected || "");
        } else {
          setbusinessSelected([]);
        }
        setLoadingApp11(false);
      },
      (err) => {
        console.log("error", err);
        setLoadingApp11(false);
      }
    );

    return () => {
      unsubscribe();
      stop = true;
    };
  }, [uid]);

  const [CompanyNAMEDetails, setCompanyNAMEDetails] = useState("");

  const [loadingApp11, setLoadingApp11] = useState(false);

  //FOR COMPANY NAME

  useEffect(() => {
    if (uid.length && businessSelected.length) {
      setLoadingApp11(true);

      const paymentDocRef20 = doc(
        firestore,
        "BusinessesAdded",
        uid,
        "businesses",
        businessSelected
      );
      getDoc(paymentDocRef20)
        .then((snapshot) => {
          if (snapshot.exists()) {
            //  console.log("snapshot data", snapshot.data());
            // If your Firestore doc structure is { ID: "..." }
            setCompanyNAMEDetails(snapshot.data().name || "");
          }
          setLoadingApp11(false);
        })
        .catch((err) => {
          console.log("error ", err.message);
          setLoadingApp11(false);
        });
    }
  }, [businessSelected, uid]);
  //console.log(CompanyNAMEDetails);

  const handleLogout = async (e) => {
    e.preventDefault();
    try {
      setErrorMessage("");

      // firebase function to logout user -from context file
      await logout();

      //

      localStorage.removeItem("noSelection");
      // we can use useHistory from react router to push to the component in brackets.
      historyPage("/Login");
    } catch {
      setErrorMessage("Logout unsuccessful");
    }
  };

  return (
    <div className="account-actions">
      <nav className="account-actions__nav" aria-label="Account actions">
        <Link
          to="/Businesses"
          title={CompanyNAMEDetails}
          className="account-business-link"
        >
          {(
            (CompanyNAMEDetails && (CompanyNAMEDetails || "")?.toString()) ||
            "Your website"
          )?.slice(0, 50)}
        </Link>

        <button className="account-logout-button" onClick={handleLogout}>
          Logout
        </button>
      </nav>
      {errorMessage && (
        <div className="alert alert-warning" role="alert">
          {errorMessage}
        </div>
      )}
    </div>
  );
};
export default Logout;
